import {
    CREATEBUSINESSNATUREMAPPING_SUCCESS,
    CREATEBUSINESSNATUREMAPPING_FAILED,
    RESET_CREATEBUSINESSNATUREMAPPING,
    LOADING_CREATEBUSINESSNATUREMAPPING,
    NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING,
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetCreateBusinessNatureMapping = () => {
    return { type: RESET_CREATEBUSINESSNATUREMAPPING };
};

const createBusinessNatureMapping =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_CREATEBUSINESSNATUREMAPPING });
        await adminServices
            .post("createBusinessNatureMapping", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.status) {
                    case 200:
                        dispatch(createBusinessNatureMappingsuccess(res.data));
                        break;
                    default:
                        dispatch(createBusinessNatureMappingFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_CREATEBUSINESSNATUREMAPPING,
                    payload: err,
                });
            });
    };
function createBusinessNatureMappingsuccess(data) {
    return {
        type: CREATEBUSINESSNATUREMAPPING_SUCCESS,
        payload: data,
    };
}
function createBusinessNatureMappingFailed(data) {
    return {
        type: CREATEBUSINESSNATUREMAPPING_FAILED,
        payload: data,
    };
}

export { resetCreateBusinessNatureMapping, createBusinessNatureMapping };
